/* tslint:disable */
/* eslint-disable */
/**
 * Donio
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccessDeniedExceptionResponse,
  ApiRequestValidationExceptionResponse,
  BadRequestExceptionResponse,
  InternalServerErrorExceptionResponse,
  NotFoundExceptionResponse,
  ProjectBeneficiaryResponse,
  ProjectDetailResponse,
  ProjectDonationsListResponse,
  ProjectListResponse,
  ProjectPhotosResponse,
  ProjectPosterSendEmailRequest,
  ProjectPosterSendEmailResponse,
  RecommendedProjectsResponse,
} from '../models/index';
import {
    AccessDeniedExceptionResponseFromJSON,
    AccessDeniedExceptionResponseToJSON,
    ApiRequestValidationExceptionResponseFromJSON,
    ApiRequestValidationExceptionResponseToJSON,
    BadRequestExceptionResponseFromJSON,
    BadRequestExceptionResponseToJSON,
    InternalServerErrorExceptionResponseFromJSON,
    InternalServerErrorExceptionResponseToJSON,
    NotFoundExceptionResponseFromJSON,
    NotFoundExceptionResponseToJSON,
    ProjectBeneficiaryResponseFromJSON,
    ProjectBeneficiaryResponseToJSON,
    ProjectDetailResponseFromJSON,
    ProjectDetailResponseToJSON,
    ProjectDonationsListResponseFromJSON,
    ProjectDonationsListResponseToJSON,
    ProjectListResponseFromJSON,
    ProjectListResponseToJSON,
    ProjectPhotosResponseFromJSON,
    ProjectPhotosResponseToJSON,
    ProjectPosterSendEmailRequestFromJSON,
    ProjectPosterSendEmailRequestToJSON,
    ProjectPosterSendEmailResponseFromJSON,
    ProjectPosterSendEmailResponseToJSON,
    RecommendedProjectsResponseFromJSON,
    RecommendedProjectsResponseToJSON,
} from '../models/index';

export interface GetProjectBeneficiaryRequest {
    id: string;
}

export interface GetProjectByIdRequest {
    id: string;
}

export interface GetProjectByNumericIdRequest {
    numericId: number;
}

export interface GetProjectBySlugRequest {
    slug: string;
}

export interface GetProjectDonationsRequest {
    id: string;
    limit?: number;
    offset?: number;
}

export interface GetProjectPhotosRequest {
    id: string;
}

export interface GetProjectPosterHtmlRequest {
    sourceType: GetProjectPosterHtmlSourceTypeEnum;
    id: string;
}

export interface GetProjectPosterPdfRequest {
    sourceType: GetProjectPosterPdfSourceTypeEnum;
    id: string;
}

export interface GetProjectsRequest {
    projectModeGroup?: GetProjectsProjectModeGroupEnum;
    user?: string | null;
    organization?: string | null;
    category?: string | null;
    topic?: string | null;
    statuses?: Array<GetProjectsStatusesEnum>;
    isLongTerm?: GetProjectsIsLongTermEnum;
    sort?: GetProjectsSortEnum;
    limit?: number;
    offset?: number;
}

export interface GetRecommendedProjectsRequest {
    id: string;
    limit?: number;
}

export interface PostSendPosterByEmailRequest {
    id: string;
    projectPosterSendEmailRequest?: ProjectPosterSendEmailRequest;
}

/**
 * 
 */
export class ProjectsApi extends runtime.BaseAPI {

    /**
     */
    async getProjectBeneficiaryRaw(requestParameters: GetProjectBeneficiaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectBeneficiaryResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getProjectBeneficiary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/projects/{id}/beneficiary`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectBeneficiaryResponseFromJSON(jsonValue));
    }

    /**
     */
    async getProjectBeneficiary(requestParameters: GetProjectBeneficiaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectBeneficiaryResponse> {
        const response = await this.getProjectBeneficiaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * All base info about project
     */
    async getProjectByIdRaw(requestParameters: GetProjectByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectDetailResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getProjectById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/projects/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectDetailResponseFromJSON(jsonValue));
    }

    /**
     * All base info about project
     */
    async getProjectById(requestParameters: GetProjectByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectDetailResponse> {
        const response = await this.getProjectByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * All base info about project
     */
    async getProjectByNumericIdRaw(requestParameters: GetProjectByNumericIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectDetailResponse>> {
        if (requestParameters['numericId'] == null) {
            throw new runtime.RequiredError(
                'numericId',
                'Required parameter "numericId" was null or undefined when calling getProjectByNumericId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/projects/numeric-id/{numericId}`.replace(`{${"numericId"}}`, encodeURIComponent(String(requestParameters['numericId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectDetailResponseFromJSON(jsonValue));
    }

    /**
     * All base info about project
     */
    async getProjectByNumericId(requestParameters: GetProjectByNumericIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectDetailResponse> {
        const response = await this.getProjectByNumericIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * All base info about project
     */
    async getProjectBySlugRaw(requestParameters: GetProjectBySlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectDetailResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getProjectBySlug().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/projects/slug/{slug}`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectDetailResponseFromJSON(jsonValue));
    }

    /**
     * All base info about project
     */
    async getProjectBySlug(requestParameters: GetProjectBySlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectDetailResponse> {
        const response = await this.getProjectBySlugRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List of paid donations associated with the project, ordered by donation order
     */
    async getProjectDonationsRaw(requestParameters: GetProjectDonationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectDonationsListResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getProjectDonations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/projects/{id}/donations`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectDonationsListResponseFromJSON(jsonValue));
    }

    /**
     * List of paid donations associated with the project, ordered by donation order
     */
    async getProjectDonations(requestParameters: GetProjectDonationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectDonationsListResponse> {
        const response = await this.getProjectDonationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getProjectPhotosRaw(requestParameters: GetProjectPhotosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectPhotosResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getProjectPhotos().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/projects/{id}/photos`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectPhotosResponseFromJSON(jsonValue));
    }

    /**
     */
    async getProjectPhotos(requestParameters: GetProjectPhotosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectPhotosResponse> {
        const response = await this.getProjectPhotosRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getProjectPosterHtmlRaw(requestParameters: GetProjectPosterHtmlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['sourceType'] == null) {
            throw new runtime.RequiredError(
                'sourceType',
                'Required parameter "sourceType" was null or undefined when calling getProjectPosterHtml().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getProjectPosterHtml().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sourceType'] != null) {
            queryParameters['sourceType'] = requestParameters['sourceType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/projects/{id}/poster/html`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getProjectPosterHtml(requestParameters: GetProjectPosterHtmlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getProjectPosterHtmlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getProjectPosterPdfRaw(requestParameters: GetProjectPosterPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['sourceType'] == null) {
            throw new runtime.RequiredError(
                'sourceType',
                'Required parameter "sourceType" was null or undefined when calling getProjectPosterPdf().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getProjectPosterPdf().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sourceType'] != null) {
            queryParameters['sourceType'] = requestParameters['sourceType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/projects/{id}/poster/pdf`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async getProjectPosterPdf(requestParameters: GetProjectPosterPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getProjectPosterPdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getProjectsRaw(requestParameters: GetProjectsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['projectModeGroup'] != null) {
            queryParameters['projectModeGroup'] = requestParameters['projectModeGroup'];
        }

        if (requestParameters['user'] != null) {
            queryParameters['user'] = requestParameters['user'];
        }

        if (requestParameters['organization'] != null) {
            queryParameters['organization'] = requestParameters['organization'];
        }

        if (requestParameters['category'] != null) {
            queryParameters['category'] = requestParameters['category'];
        }

        if (requestParameters['topic'] != null) {
            queryParameters['topic'] = requestParameters['topic'];
        }

        if (requestParameters['statuses'] != null) {
            queryParameters['statuses'] = requestParameters['statuses'];
        }

        if (requestParameters['isLongTerm'] != null) {
            queryParameters['isLongTerm'] = requestParameters['isLongTerm'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/projects`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectListResponseFromJSON(jsonValue));
    }

    /**
     */
    async getProjects(requestParameters: GetProjectsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectListResponse> {
        const response = await this.getProjectsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getRecommendedProjectsRaw(requestParameters: GetRecommendedProjectsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RecommendedProjectsResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getRecommendedProjects().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/projects/{id}/recommended`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RecommendedProjectsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getRecommendedProjects(requestParameters: GetRecommendedProjectsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RecommendedProjectsResponse> {
        const response = await this.getRecommendedProjectsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async postSendPosterByEmailRaw(requestParameters: PostSendPosterByEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectPosterSendEmailResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling postSendPosterByEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/projects/{id}/poster/send-email`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProjectPosterSendEmailRequestToJSON(requestParameters['projectPosterSendEmailRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectPosterSendEmailResponseFromJSON(jsonValue));
    }

    /**
     */
    async postSendPosterByEmail(requestParameters: PostSendPosterByEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectPosterSendEmailResponse> {
        const response = await this.postSendPosterByEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetProjectPosterHtmlSourceTypeEnum = {
    TyPage: 'ty-page',
    Other: 'other'
} as const;
export type GetProjectPosterHtmlSourceTypeEnum = typeof GetProjectPosterHtmlSourceTypeEnum[keyof typeof GetProjectPosterHtmlSourceTypeEnum];
/**
 * @export
 */
export const GetProjectPosterPdfSourceTypeEnum = {
    TyPage: 'ty-page',
    Other: 'other'
} as const;
export type GetProjectPosterPdfSourceTypeEnum = typeof GetProjectPosterPdfSourceTypeEnum[keyof typeof GetProjectPosterPdfSourceTypeEnum];
/**
 * @export
 */
export const GetProjectsProjectModeGroupEnum = {
    Dobro: 'dobro',
    Plus: 'plus'
} as const;
export type GetProjectsProjectModeGroupEnum = typeof GetProjectsProjectModeGroupEnum[keyof typeof GetProjectsProjectModeGroupEnum];
/**
 * @export
 */
export const GetProjectsStatusesEnum = {
    UserDraft: 'user-draft',
    UserDraftSubmitted: 'user-draft-submitted',
    UserDraftReturned: 'user-draft-returned',
    UserDraftRejected: 'user-draft-rejected',
    Draft: 'draft',
    Cancelled: 'cancelled',
    Scheduled: 'scheduled',
    Active: 'active',
    Finished: 'finished',
    Closed: 'closed'
} as const;
export type GetProjectsStatusesEnum = typeof GetProjectsStatusesEnum[keyof typeof GetProjectsStatusesEnum];
/**
 * @export
 */
export const GetProjectsIsLongTermEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type GetProjectsIsLongTermEnum = typeof GetProjectsIsLongTermEnum[keyof typeof GetProjectsIsLongTermEnum];
/**
 * @export
 */
export const GetProjectsSortEnum = {
    PriorityAsc: 'priority:ASC',
    PriorityDesc: 'priority:DESC',
    DonioRankAsc: 'donioRank:ASC',
    DonioRankDesc: 'donioRank:DESC',
    StartedAtAsc: 'startedAt:ASC',
    StartedAtDesc: 'startedAt:DESC',
    NameAsc: 'name:ASC',
    NameDesc: 'name:DESC',
    CreatedAtAsc: 'createdAt:ASC',
    CreatedAtDesc: 'createdAt:DESC',
    CoordinatesAsc: 'coordinates:ASC',
    CoordinatesDesc: 'coordinates:DESC'
} as const;
export type GetProjectsSortEnum = typeof GetProjectsSortEnum[keyof typeof GetProjectsSortEnum];
